import { Launch } from '@mui/icons-material';
import { Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';
import FlexBox from '../../components/flexbox/flexbox';
import { WINEFO_BLOG } from '../../constants/urls';
import SettingsItem from './settings-item';
import { ROUTES } from '../../constants/routes';

const OtherSettingsSection = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const locationState = { from: { pathname: ROUTES.SETTINGS } };
  const navigateToPrivacyPolicy = () => {
    navigate(ROUTES.PRIVACY_POLICY, { state: locationState });
  };
  const navigateToTermsAndConditions = () => {
    navigate(ROUTES.TERMS_AND_CONDITIONS, { state: locationState });
  };

  return (
    <FlexBox mx={2} flexDirection="column" gap={1}>
      <Typography sx={{ my: 1.5, ml: 0.5 }}>
        {t('settings.other-settings')}
      </Typography>
      <SettingsItem onClick={navigateToTermsAndConditions}>
        {t('settings.terms-conditions')}
      </SettingsItem>
      <SettingsItem onClick={navigateToPrivacyPolicy}>
        {t('common.privacy-policy')}
      </SettingsItem>
      <Link to={WINEFO_BLOG} target="_blank">
        <SettingsItem
          sx={{
            textDecoration: 'underline',
          }}
          startIcon={<Launch />}
          endIcon=""
        >
          {WINEFO_BLOG.replace('https://www.', '')}
        </SettingsItem>
      </Link>
    </FlexBox>
  );
};

export default OtherSettingsSection;
